import { NotificationMenu, Text } from '@bbl-digital/snorre-v2'

import { useAppSelector } from 'shared/store/store'
import { getNotifications } from 'shared/store/notifications/selectors'
import { FC, useEffect, useState } from 'react'
import NotificationItem from './NotificationItem'
import { useBroadcast } from 'shared/hooks/useBroadcast'
import { NOTIFICATION_RECEIVED } from 'shared/constants/broadcastChannels'

interface Props {
  dark?: boolean
}

const Notifications: FC<Props> = ({ dark }) => {
  const [triggerClose, setTriggerClose] = useState(0)
  const data = useAppSelector(getNotifications)
  const hasNotifications = Boolean(data?.length)

  const { subscribe } = useBroadcast<boolean>(NOTIFICATION_RECEIVED)
  const [shouldShake, setShouldShake] = useState(false)

  useEffect(() => {
    const sub = subscribe(async (notificationReceived) => {
      if (notificationReceived) setShouldShake(true)
      setTimeout(() => setShouldShake(false), 4000)
    })
    return () => sub()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <NotificationMenu
      dark={dark}
      onSelect={(e) => console.log(e)}
      unread={data.length}
      shake={shouldShake}
    >
      <NotificationMenu.Header>
        <Text weight="bold" variant="subtitle">
          Varsler
        </Text>
        {/*
          TODO: Needs an endpoint
         {hasNotifications && data?.length > 1 && (
          <Button variant="link">Merk alle som lest</Button>
        )} */}
      </NotificationMenu.Header>
      {hasNotifications && (
        <NotificationMenu.List>
          {data.map((notification, index) => {
            return (
              <NotificationItem
                key={notification.id}
                triggerClose={() => setTriggerClose(triggerClose + 1)}
                hideBorderBottom={index === data.length - 1}
                {...notification}
              />
            )
          })}
        </NotificationMenu.List>
      )}
      {!hasNotifications && (
        <div className="w-[200px] p-md justify-center flex">
          <Text subtle>Ingen nye varsler</Text>
        </div>
      )}
    </NotificationMenu>
  )
}

export default Notifications
